export const getYear = state => state.reportCostCenterCost.getIn(['list', 'year'])

export const getData = state => state.reportCostCenterCost.getIn(['list', 'data'])
export const getFetching = state => state.reportCostCenterCost.getIn(['list', 'fetching'])
export const getError = state => state.reportCostCenterCost.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCostCenterCost.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCostCenterCost.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCostCenterCost.getIn(['details', 'error'])
